import { gql } from "graphql-request";

export const SIGN_IN_WITH_CODE_MUTATION = gql`
  mutation SignInOrSignUpByCode(
    $code: String!
    $provider: String!
    $name: String
    $isMobile: Boolean
    $isAdmin: Boolean
  ) {
    signInOrSignUpByCode(
      OAuthCredential: {
        code: $code
        provider: $provider
        name: $name
        isMobile: $isMobile
        isAdmin: $isAdmin
      }
    ) {
      accessToken
      user {
        _id
        email
        name
      }
    }
  }
`;

export const GET_ME_QUERY = gql`
  query GetMe {
    getMe {
      _id
      email
      name
    }
  }
`;

export const LOGOUT_MUTATION = gql`
  mutation Logout {
    logout
  }
`;
